<template>
  <EditForm :question="question"/>
</template>

<script>
import EditForm from '@/pages/admin/questions/thematic/EditForm'
import ThematicQuestionService from '@/services/ThematicQuestionService'

export default {
  components: {EditForm},
  data: () => ({
    question: ThematicQuestionService.getDefaultItem()
  })
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/questions/thematic/Add.vue